var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2809 13.6322C13.2809 14.0982 12.9018 14.4772 12.4359 14.4772H3.56413C3.09821 14.4772 2.71914 14.0982 2.71914 13.6322V11.8841V7.66994V5.92181C2.71914 5.45588 3.09821 5.07682 3.56413 5.07682H12.4359C12.9018 5.07682 13.2809 5.45588 13.2809 5.92181V7.66994V11.8841V13.6322Z",
    fill: "url(#paint0_linear_399_235)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4035 7.27285H14.075V5.92181C14.075 5.01799 13.3398 4.28263 12.4359 4.28263H8.39709V3.36714C9.0105 3.19353 9.46175 2.62988 9.46175 1.96165C9.46175 1.15574 8.80602 0.5 8 0.5C7.19398 0.5 6.53825 1.15574 6.53825 1.96165C6.53825 2.6299 6.9895 3.19353 7.60291 3.36714V4.28263H3.56413C2.66021 4.28263 1.92496 5.01797 1.92496 5.92181V7.27285H1.59651C0.716234 7.27285 0 7.98898 0 8.86926V10.6849C0 11.565 0.716234 12.2812 1.59651 12.2812H1.92496V13.6322C1.92496 14.536 2.66019 15.2714 3.56413 15.2714H12.4359C13.3398 15.2714 14.075 14.536 14.075 13.6322V12.2812H14.4035C15.2838 12.2812 16 11.565 16 10.6849V8.86926C16 7.98898 15.2837 7.27285 14.4035 7.27285ZM8 1.29418C7.632 1.29418 7.33243 1.59365 7.33243 1.96165C7.33243 2.32976 7.632 2.62922 8 2.62922C8.368 2.62922 8.66757 2.32976 8.66757 1.96165C8.66757 1.59365 8.368 1.29418 8 1.29418ZM0.794183 10.6849C0.794183 11.1271 1.15405 11.487 1.59651 11.487L1.92496 11.487V8.06705H1.59651C1.15405 8.06705 0.794183 8.42692 0.794183 8.86928V10.6849ZM12.4359 14.4772C12.9018 14.4772 13.2809 14.0982 13.2809 13.6322V11.8841V7.66994V5.92181C13.2809 5.45588 12.9018 5.07682 12.4359 5.07682H3.56413C3.09821 5.07682 2.71914 5.45588 2.71914 5.92181V7.66994V11.8841V13.6322C2.71914 14.0982 3.09821 14.4772 3.56413 14.4772H12.4359ZM14.4035 11.487C14.846 11.487 15.2058 11.1271 15.2058 10.6849V8.86926C15.2058 8.4269 14.846 8.06703 14.4035 8.06703H14.075V11.487H14.4035Z",
    fill: "url(#paint1_linear_399_235)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1776 7.34766C9.39832 7.34766 8.76428 7.98169 8.76428 8.76094C8.76428 9.54029 9.39832 10.1743 10.1776 10.1743C10.9568 10.1743 11.5909 9.54029 11.5909 8.76094C11.5908 7.98169 10.9568 7.34766 10.1776 7.34766ZM10.1776 9.38013C9.83613 9.38013 9.55846 9.10238 9.55846 8.76092C9.55846 8.41958 9.83611 8.14182 10.1776 8.14182C10.519 8.14182 10.7967 8.41956 10.7967 8.76092C10.7967 9.10238 10.519 9.38013 10.1776 9.38013Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82235 7.34766C5.04309 7.34766 4.40906 7.98169 4.40906 8.76094C4.40906 9.54029 5.04309 10.1743 5.82235 10.1743C6.6016 10.1743 7.23563 9.54029 7.23563 8.76094C7.23563 7.98169 6.6016 7.34766 5.82235 7.34766ZM5.82235 9.38013C5.48091 9.38013 5.20324 9.10238 5.20324 8.76092C5.20324 8.41958 5.48089 8.14182 5.82235 8.14182C6.16378 8.14182 6.44145 8.41956 6.44145 8.76092C6.44145 9.10238 6.1638 9.38013 5.82235 9.38013Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_399_235",
    x1: 8,
    y1: 0.5,
    x2: 8,
    y2: 15.2714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_399_235",
    x1: 8,
    y1: 0.5,
    x2: 8,
    y2: 15.2714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0288D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013958"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedBot);
export default __webpack_public_path__ + "static/media/selectedBot.d4def888693da88c08ead4860f824c2c.svg";
export { ForwardRef as ReactComponent };